export default __webpack_public_path__ + "static/media/Image4.43e64039.png";